<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        Settlement Pelunasan
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button
            class="btn btn-success mr-1"
            v-b-tooltip.hover
            title
            @click="settlement()"
          >
            <i class="fa fa-money"></i> {{ $t("settlement") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Tgl.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.tgl_kontrak"
                  readonly
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.pinjaman_uraian"
              readonly
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman == 'PAB'">
                <label style="width: 140px">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width: 140px">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman == 'PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="0"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman == 'PAB'">
              <b-input-group-prepend>
                <label style="width: 140px">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px">Pelunasan Secara</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="frmdt.tipepelunasan"
              :options="optionsPelunasan"
              class="mb-3 mt-1"
              value-field="item"
              text-field="name"
              disabled
            ></b-form-radio-group>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px">Tgl Pelunasan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdt.tglmulaipelunasan"
              v-if="ifBertahap"
              disabled
            ></b-form-input>
            <!-- :state="!$v.frmdt.tglmulaipelunasan.$error" -->
            <b-input-group-prepend v-if="ifBertahap">
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdt.tglpelunasan"
              class="mr-2"
              disabled
            ></b-form-input>
            <!-- :min="new Date | moment('YYYY-MM-DD')" -->
            <b-button
              variant="danger"
              v-b-tooltip.hover
              title="Hitung biaya pelunasan"
              @click="calculate"
              disabled
            >
              <i class="fa fa-calculator"></i> Calc.
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="mt-3" v-if="model.model_pinjaman == 'PAB'">
        <b-col lg="5">
          <h5>
            Posisi sampai hari ini {{ model.hariini | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipalcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Bunga</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterestcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Denda</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttllatechargecurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>

        <!-- <b-col lg="5">
          <h5>Posisi sampai tgl pelunasan {{frmdt.tglpelunasan | moment('DD-MMM-YYYY')}}</h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlprincipal" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Bunga</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlinterest" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Denda</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttllatecharge" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
        </b-col> -->
      </b-row>
      <!-- end PAB -->
      <b-row class="mt-3" v-else>
        <b-col lg="5">
          <h5>
            Posisi sampai hari ini {{ frmdt.hariini | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Saldo Pokok</label>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipalcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Bunga & OD</label>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterestcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>
      <hr />

      <b-row class="mt-3" v-if="model.model_pinjaman == 'PAB'">
        <b-col lg="4">
          <h5>
            Posisi sampai tgl pelunasan
            {{ frmdt.tglpelunasan | moment("DD-MMM-YYYY") }}
          </h5>
          <!-- <h5>Keterangan</h5> -->
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlprincipal" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:160px !important;">Total Bunga</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height:35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlinterest" :precision="2" class="text-right" disabled></my-number>
          </b-input-group> -->

          <b-input-group>
            <b-input-group-prepend>
              <h5 style="width: 160px !important">Keterangan</h5>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <h5>Amount Awal</h5>
            </b-input-group-prepend>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">OS Pokok Belum JT</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ospokokbelumjt"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Tunggakan Angsuran</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlangsuran"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Bunga Berjalan</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterest"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Denda Angsuran</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttllatecharge"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Denda Lainnya</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.dendalain"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">8% Pinalty</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.pinalty"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>

          <hr />
          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Total</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text ml-4">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment_awal"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <!-- :state="stateTtlPay" -->
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Prepaid</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8"></b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Jumlah yang harus masih dibayar</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8"></b-col>
          </b-row>
        </b-col>

        <b-col lg="3">
          <h5>&nbsp;</h5>
          <h5>Diskon</h5>
          <!-- <b-row no-gutters>
            <b-col md="5">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">Diskon Pokok</span>
                </b-input-group-prepend>
                <my-number v-model="diskon_principal_percent" :precision="2" class="text-right"></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number v-model="diskon_principal_amount" :precision="2" class="text-right"></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="5">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">Diskon Bunga</span>
                </b-input-group-prepend>
                <my-number v-model="diskon_interest_percent" :precision="2" class="text-right"></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="7">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number v-model="diskon_interest_amount" :precision="2" class="text-right"></my-number>
              </b-input-group>
            </b-col>
          </b-row> -->

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">
                    <!-- Diskon OS Pokok Belum JT -->
                  </span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_ospokokbelumjt_percent"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_ospokokbelumjt_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">
                    <!-- Diskon Angsuran -->
                  </span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_angsuran_percent"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_angsuran_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">
                    <!-- Diskon Bunga Berjalan -->
                  </span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_interest_percent"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_interest_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">
                    <!-- Diskon Denda -->
                  </span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_latecharge_percent"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_latecharge_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">
                    <!-- Diskon Denda Lainnya -->
                  </span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_dendalain_percent"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_dendalain_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2 mr-1">
                    <!-- Diskon Pinalty -->
                  </span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_pinalty_percent"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="diskon_pinalty_amount"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <hr />
          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    <!-- Total Diskon -->
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment_diskon"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <!-- :state="stateTtlPay" -->
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    <!-- empty -->
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <!-- <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment_diskon"
                  :state="stateTtlPay"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group> -->
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="4">
          <h5>&nbsp;</h5>
          <h5>Net Amount</h5>
          <!-- <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Net Pokok</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttlprincipal"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Net Bunga</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttlinterest"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row> -->

          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Net OS Pokok Belum JT
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ospokokbelumjt"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Net Angsuran
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttlangsuran"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <!-- :state="stateTtlPay" -->
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Net Bunga Berjalan
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttlinterest"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Net Denda Angsuran
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_ttllatecharge"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
                <!-- :state="stateTtlPay" -->
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Net Denda Lainnya
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_dendalain"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Net Pinalty
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.net_pinalty"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <hr />
          <b-row no-gutters>
            <!-- <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>
                    Total Pelunasan
                  </label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col> -->
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlpayment"
                  :precision="2"
                  class="text-right"
                  style="padding-right: 11px"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.prepaid"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.ttlmustpay"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- end PAB -->
      <b-row class="mt-3" v-else>
        <b-col lg="5">
          <h5>
            Posisi sampai tgl pelunasan
            {{ frmdt.tglpelunasan | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Saldo Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipal"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Bunga & OD</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterest"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-row class="mt-3">
        <b-col lg="4">
          <b-row no-gutters>
            <b-col md="4">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Jumlah pelunasan yang sudah dibayar</label>
                </b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col md="8"></b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-row no-gutters>
            <b-col md="8">
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <my-number
                  v-model="frmdt.cicilan_pelunasan"
                  :precision="2"
                  class="text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <!-- <b-row no-gutters>
        <b-col md="4">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Deal Amount</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.deal_amt"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>
      <hr /> -->
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tanggal Surat</label>
            </b-input-group-prepend>
            <b-input type="date" v-model="frmdt.tglsurat" disabled />
          </b-input-group>
          <!-- :state="!$v.frmdt.tglsurat.$error"  -->

          <b-input-group>
            <b-input-group-prepend>
              <label>Nomor Surat</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.nosurat" disabled></b-form-input>
          </b-input-group>
          <!-- :state="!$v.frmdt.nosurat.$error" -->

          <b-input-group>
            <b-input-group-prepend>
              <label>Kepada</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.kepada" disabled></b-form-input>
          </b-input-group>
          <!-- :state="!$v.frmdt.kepada.$error" -->

          <b-input-group>
            <b-input-group-prepend>
              <label>Perihal</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.perihal" disabled></b-form-input>
          </b-input-group>
          <!-- :state="!$v.frmdt.perihal.$error" -->

          <b-input-group>
            <b-input-group-prepend>
              <label>Lokasi / LDSK</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.lokasiLDSK1" disabled></b-form-input>
            <b-form-input v-model="frmdt.lokasiLDSK2" disabled></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Kronologis</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="frmdt.kronologis"
              placeholder=""
              rows="4"
              max-rows="6"
              disabled
            ></b-form-textarea>
          </b-input-group>
          <!-- :state="!$v.frmdt.kronologis.$error" -->

          <b-input-group>
            <b-input-group-prepend>
              <label>CC</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="frmdt.cc"
              placeholder=""
              rows="4"
              max-rows="6"
              disabled
            ></b-form-textarea>
          </b-input-group>
          <!-- :state="!$v.frmdt.cc.$error" -->
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col lg="4">
          <h6 class="text-center">Diajukan Oleh</h6>
          <h6 class="text-center">{{ frmdt.ttd1_diajukan_nama }}</h6>
          <h6 class="text-center">{{ frmdt.ttd1_diajukan_jabatan }}</h6>
        </b-col>
        <b-col lg="4">
          <h6 class="text-center">Mengetahui</h6>
          <h6 class="text-center">{{ frmdt.ttd1_mengetahui_nama }}</h6>
          <h6 class="text-center">{{ frmdt.ttd1_mengetahui_jabatan }}</h6>
        </b-col>
        <b-col lg="4">
          <h6 class="text-center">Disetujui Oleh</h6>
          <h6 class="text-center">{{ frmdt.ttd1_disetujui_nama }}</h6>
          <h6 class="text-center">{{ frmdt.ttd1_disetujui_jabatan }}</h6>
        </b-col>
      </b-row>
      <hr />
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";

// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading },
  mixins: [validationMixin],
  validations: {
    frmdt: {
      pinjamankey: { required },
      //tglmulaipelunasan: { required },
      //tglpelunasan: { required },
      // tglsurat: { required },
      // nosurat: { required },
      // kepada: { required },
      // perihal: { required },
      // kronologis: {
      //   required: requiredIf(function () {
      //     return this.canSave;
      //   }),
      //  },
      // cc: {
      //   required: requiredIf(function () {
      //     return this.canSave;
      //   }),
      //  },
      // ttd1_diajukan_nama: { required },
      // ttd1_diajukan_jabatan: { required },
      // ttd1_mengetahui_nama: { required },
      // ttd1_mengetahui_jabatan: { required },
      // ttd1_disetujui_nama: { required },
      // ttd1_disetujui_jabatan: { required },
    },
  },
  data() {
    return {
      showReport: false,
      reportUrl: null,
      isLoading: false,
      text: "",
      isBusy: false,
      isPelunasankey: false,
      model: {},
      frmdt: {
        statussp: null,
        pinjamankey: "",
        hariini: moment().format("YYYY-MM-DD"),
        nosurat: "",
        kepada: "",
        perihal: "",
        lokasiLDSK1: "",
        lokasiLDSK2: "",
        kronologis: "",
        cc: "",
        ttd1_diajukan_nama: "",
        ttd1_diajukan_jabatan: "",
        ttd1_mengetahui_nama: "",
        ttd1_mengetahui_jabatan: "",
        ttd1_disetujui_nama: "",
        ttd1_disetujui_jabatan: "",
        // uraian: "",
        ttlinstalmentcurrent: 0,
        ttllatechargecurrent: 0,
        ttlprincipalcurrent: 0,
        ttlinterestcurrent: 0,
        ttlinstalment: 0,
        ttlprincipal: 0,
        ttllatecharge: 0,
        ttlinterest: 0,
        ttlangsuran: 0,
        ospokokbelumjt: 0,
        dendalain: 0,
        pinalty: 0,
        // diskon_percent: 0,
        // diskon_amount: 0,

        diskon_principal_percent: 0,
        diskon_principal_amount: 0,
        diskon_interest_percent: 0,
        diskon_interest_amount: 0,

        diskon_angsuran_percent: 0,
        diskon_angsuran_amount: 0,

        diskon_latecharge_percent: 0,
        diskon_latecharge_amount: 0,

        diskon_ospokokbelumjt_percent: 0,
        diskon_ospokokbelumjt_amount: 0,
        diskon_dendalain_percent: 0,
        diskon_dendalain_amount: 0,
        diskon_pinalty_percent: 0,
        diskon_pinalty_amount: 0,

        net_ttlprincipal: 0,
        net_ttlinterest: 0,

        net_ttlangsuran: 0,

        net_ttllatecharge: 0,

        net_ospokokbelumjt: 0,
        net_dendalain: 0,
        net_pinalty: 0,

        ttlpayment_awal: 0,
        ttlpayment_diskon: 0,
        ttlpayment: 0,
        prepaid: 0,
        ttlmustpay: 0,
        tipepelunasan: "Normal",
      },
      // diskon_percent: 0,
      // diskon_amount: 0,
      diskon_principal_percent: 0,
      diskon_principal_amount: 0,
      diskon_interest_percent: 0,
      diskon_interest_amount: 0,

      diskon_angsuran_percent: 0,
      diskon_angsuran_amount: 0,

      diskon_latecharge_percent: 0,
      diskon_latecharge_amount: 0,

      diskon_ospokokbelumjt_percent: 0,
      diskon_ospokokbelumjt_amount: 0,
      diskon_dendalain_percent: 0,
      diskon_dendalain_amount: 0,
      diskon_pinalty_percent: 0,
      diskon_pinalty_amount: 0,

      ifCalculated: false,
      stateTtlPay: true,
      lkuPinjamanShow: false,

      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],
    };
  },
  computed: {
    invalidFrmDt() {
      this.$v.frmdt.$touch();
      return this.$v.frmdt.$invalid;
    },
    canSave() {
      return this.ifCalculated;
    },
    ifBertahap() {
      return this.frmdt.tipepelunasan == "Bertahap" ? true : false;
    },
  },
  watch: {
    // diskon_percent(val) {
    //   const pokok =
    //     this.frmdt.ttlprincipal +
    //     this.frmdt.ttllatecharge +
    //     this.frmdt.ttlinterest;
    //   this.frmdt.diskon_percent = val;
    //   this.diskon_amount = (val / 100) * pokok;
    // },
    // diskon_amount(val) {
    //   this.frmdt.diskon_amount = val;
    //   const ttlpayment =
    //     this.frmdt.ttlprincipal +
    //     this.frmdt.ttllatecharge +
    //     this.frmdt.ttlinterest;
    //   this.diskon_percent =(val/ttlpayment)*100;
    //   this.frmdt.ttlpayment = ttlpayment - val;
    // },

    diskon_principal_percent(val) {
      const pokok = this.frmdt.ttlprincipal;
      this.frmdt.diskon_principal_percent = val;
      this.diskon_principal_amount = (val / 100) * pokok;
    },
    diskon_principal_amount(val) {
      this.frmdt.diskon_principal_amount = val;
      const net_ttlprincipal = this.frmdt.ttlprincipal;
      this.diskon_principal_percent = (val / net_ttlprincipal) * 100;
      this.frmdt.net_ttlprincipal = net_ttlprincipal - val;
      //this.frmdt.ttlpayment = this.frmdt.net_ttlprincipal + this.frmdt.net_ttlinterest + this.frmdt.net_ttllatecharge;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },

    diskon_interest_percent(val) {
      const bunga = this.frmdt.ttlinterest;
      this.frmdt.diskon_interest_percent = val;
      this.diskon_interest_amount = (val / 100) * bunga;
    },
    diskon_interest_amount(val) {
      this.frmdt.diskon_interest_amount = val;
      //console.log("#val diskon_interest_amount: ", val);
      const net_ttlinterest = this.frmdt.ttlinterest;
      this.diskon_interest_percent = (val / net_ttlinterest) * 100;
      this.frmdt.net_ttlinterest = net_ttlinterest - val;
      //this.frmdt.ttlpayment = this.frmdt.net_ttlprincipal + this.frmdt.net_ttlinterest + this.frmdt.net_ttllatecharge;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },

    diskon_angsuran_percent(val) {
      const angsuran = this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
      this.frmdt.diskon_angsuran_percent = val;
      this.diskon_angsuran_amount = (val / 100) * angsuran;
    },
    diskon_angsuran_amount(val) {
      this.frmdt.diskon_angsuran_amount = val;
      const net_ttlangsuran = this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
      this.diskon_angsuran_percent = (val / net_ttlangsuran) * 100;
      this.frmdt.net_ttlangsuran = net_ttlangsuran - val;
      // this.frmdt.ttlpayment = this.frmdt.net_ttlangsuran + this.frmdt.net_ttlprincipal + this.frmdt.net_ttlinterest + this.frmdt.net_ttllatecharge;
      //this.frmdt.ttlpayment = this.frmdt.net_ttlangsuran + this.frmdt.net_ttllatecharge;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },

    diskon_latecharge_percent(val) {
      const denda = this.frmdt.ttllatecharge;
      this.frmdt.diskon_latecharge_percent = val;
      this.diskon_latecharge_amount = (val / 100) * denda;
    },
    diskon_latecharge_amount(val) {
      this.frmdt.diskon_latecharge_amount = val;
      // const ttlpayment =
      //   this.frmdt.ttllatecharge;
      // this.diskon_latecharge_percent =(val/ttlpayment)*100;
      // this.frmdt.ttlpayment = ttlpayment - val;
      const net_ttllatecharge = this.frmdt.ttllatecharge;
      this.diskon_latecharge_percent = (val / net_ttllatecharge) * 100;
      this.frmdt.net_ttllatecharge = net_ttllatecharge - val;
      // this.frmdt.ttlpayment = this.frmdt.net_ttlprincipal + this.frmdt.net_ttlinterest + this.frmdt.net_ttllatecharge;
      //this.frmdt.ttlpayment = this.frmdt.net_ttlangsuran + this.frmdt.net_ttllatecharge;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },

    diskon_ospokokbelumjt_percent(val) {
      const ospokokbelumjt = this.frmdt.ospokokbelumjt;
      this.frmdt.diskon_ospokokbelumjt_percent = val;
      this.diskon_ospokokbelumjt_amount = (val / 100) * ospokokbelumjt;
    },
    diskon_ospokokbelumjt_amount(val) {
      this.frmdt.diskon_ospokokbelumjt_amount = val;
      const net_ospokokbelumjt = this.frmdt.ospokokbelumjt;
      this.diskon_ospokokbelumjt_percent = (val / net_ospokokbelumjt) * 100;
      this.frmdt.net_ospokokbelumjt = net_ospokokbelumjt - val;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },

    diskon_dendalain_percent(val) {
      const dendalain = this.frmdt.dendalain;
      this.frmdt.diskon_dendalain_percent = val;
      this.diskon_dendalain_amount = (val / 100) * dendalain;
    },
    diskon_dendalain_amount(val) {
      this.frmdt.diskon_dendalain_amount = val;
      const net_dendalain = this.frmdt.dendalain;
      this.diskon_dendalain_percent = (val / net_dendalain) * 100;
      this.frmdt.net_dendalain = net_dendalain - val;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },

    diskon_pinalty_percent(val) {
      const pinalty = this.frmdt.pinalty;
      this.frmdt.diskon_pinalty_percent = val;
      this.diskon_pinalty_amount = (val / 100) * pinalty;
    },
    diskon_pinalty_amount(val) {
      this.frmdt.diskon_pinalty_amount = val;
      const net_pinalty = this.frmdt.pinalty;
      this.diskon_pinalty_percent = (val / net_pinalty) * 100;
      this.frmdt.net_pinalty = net_pinalty - val;
      this.frmdt.ttlpayment =
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;
      this.frmdt.ttlpayment_awal =
        this.frmdt.ospokokbelumjt +
        this.frmdt.ttlangsuran +
        this.frmdt.ttlinterest +
        this.frmdt.ttllatecharge +
        this.frmdt.dendalain +
        this.frmdt.pinalty;
      this.frmdt.ttlpayment_diskon =
        this.frmdt.diskon_ospokokbelumjt_amount +
        this.frmdt.diskon_angsuran_amount +
        this.frmdt.diskon_interest_amount +
        this.frmdt.diskon_latecharge_amount +
        this.frmdt.diskon_dendalain_amount +
        this.frmdt.diskon_pinalty_amount;
      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },
  },
  created: async function () {
    this.model.model_pinjaman = "PAB";
    if (this.$route.params.pelunasankey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isPelunasankey = true;
      try {
        const res = await pelunasan.detail(this.$route.params.pelunasankey);
        for (const key in res) {
          this.model[key] = res[key];
          this.frmdt[key] = res[key];
        }
        this.model.tgl_kontrak = this.model.tgl_kontrak
          ? moment(this.model.tgl_kontrak).format("DD-MMM-YYYY")
          : "";
        this.frmdt.tglpelunasan = this.frmdt.tglpelunasan
          ? moment(this.frmdt.tglpelunasan).format("DD-MMM-YYYY")
          : "";

        this.frmdt.tglmulaipelunasan = this.frmdt.tglmulaipelunasan
          ? moment(this.frmdt.tglmulaipelunasan).format("DD-MMM-YYYY")
          : "";

        this.frmdt.tglsurat = this.frmdt.tglsurat
          ? moment(this.frmdt.tglsurat).format("YYYY-MM-DD")
          : "";

        // this.diskon_percent = this.model.diskon_percent;
        this.diskon_principal_percent = this.model.diskon_principal_percent;
        this.diskon_interest_percent = this.model.diskon_interest_percent;
        this.diskon_angsuran_percent = this.model.diskon_angsuran_percent;
        this.diskon_latecharge_percent = this.model.diskon_latecharge_percent;
        this.diskon_ospokokbelumjt_percent = this.model.diskon_ospokokbelumjt_percent;
        this.diskon_dendalain_percent = this.model.diskon_dendalain_percent;
        this.diskon_pinalty_percent = this.model.diskon_pinalty_percent;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }

    // if (this.$route.params.pinjamankey) {
    //   toastr.info("Loading Payment Detail, please wait");
    //   try {
    //     const [res] = await pinjaman.detail(this.$route.params.pinjamankey);
    //     const pinjamanDt = res[0][0];
    //     for (const key in pinjamanDt) {
    //       this.model[key] = pinjamanDt[key];
    //     }
    //     this.model.tgl_kontrak = this.model.tgl_kontrak
    //       ? moment(this.model.tgl_kontrak).format("DD-MM-YYYY")
    //       : "";
    //     this.model.tglpelunasan = this.model.tglpelunasan
    //       ? moment(this.model.tglpelunasan).format("DD-MM-YYYY")
    //       : "";
    //     this.model.pinjaman_uraian = pinjamanDt.uraian;
    //     this.diskon_percent = this.model.diskon_percent;
    //     toastr.clear;
    //   } catch (error) {
    //     console.log("error : ", error);
    //     toastr.error(JSON.stringify(error), "ERROR MESSAGE");
    //   }
    // }
  },
  methods: {
    async onSelectLkuPinjaman(_selected) {
      this.resetCalc();
      this.frmdt.pinjamankey = _selected.pinjamankey;
      this.frmdt.nasabahkey = _selected.nasabahkey;
      for (const key in _selected) {
        this.model[key] = _selected[key];
      }
      this.model.tgl_kontrak = _selected.tgl_kontrak
        ? moment(_selected.tgl_kontrak).format("DD-MM-YYYY")
        : "";
      this.model.pinjaman_uraian = _selected.uraian;
      this.model.ttllatecharge = 0;
      this.lkuPinjamanShow = false;
    },
    async calculate() {
      try {
        //console.log("#this.frmdt: ", this.frmdt);
        if (this.invalidFrmDt) {
          // console.log("validation : ", this.$v.issuedLinesObj);
          // console.log("model obj : ", this.issuedLinesObj);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.isLoading = true;
          const data = await pinjaman.calcpelunasan(this.frmdt);
          //console.log("#data: ", data);
          const today = moment();
          const tglpelunasan = moment(this.frmdt.tglpelunasan);
          let diffDays = tglpelunasan.diff(today, "days");

          //console.log("diffDays: ", diffDays);

          // const tglmulaipelunasan = moment(this.frmdt.tglmulaipelunasan);
          // let diffMonth = Math.ceil(tglpelunasan.diff(tglmulaipelunasan, "months", true));
          // console.log("diffMonth: ", diffMonth);

          const {
            model_pinjaman,
            principal: pjmPrincipal,
            duedate: ODdate,
            bungaod_tarifthn,
            bunga_tarifthn,
          } = this.model;
          const { bbnPinjamanCurr, bbnPinjamanPelunasan } = data;
          //console.log("#bbnPinjamanCurr: ", bbnPinjamanCurr);
          //console.log("#bbnPinjamanPelunasan: ", bbnPinjamanPelunasan);

          // START total beban sampai hari ini
          this.frmdt.ttlinstalmentcurrent =
            bbnPinjamanCurr.sum_angsrn_installment;
          this.frmdt.ttlprincipalcurrent = bbnPinjamanCurr.sum_angsrn_principal;
          this.frmdt.ttlinterestcurrent = bbnPinjamanCurr.sum_angsrn_interest;
          this.frmdt.ttllatechargecurrent =
            bbnPinjamanCurr.sum_nilai_dendahrian;
          // END

          if (model_pinjaman == "PRK") {
            // current
            this.frmdt.ttlprincipalcurrent = pjmPrincipal;
            this.frmdt.ttlinterestcurrent =
              bbnPinjamanCurr.sum_bungahrian_interest;
            // sampai pelunasan
            this.frmdt.ttlprincipal = pjmPrincipal;
            this.frmdt.ttlinterest =
              bbnPinjamanPelunasan.sum_bungahrian_interest;

            this.frmdt.ttlangsuran =
              this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
            this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
            this.frmdt.dendalain = 0; //tanyakan kembali dendalain
            this.frmdt.pinalty = 0; //tanyakan kembali pinalty

            if (diffDays > 0) {
              diffDays += 1;
              let diffODDays = today.diff(moment(ODdate), "days");
              let ifOverDue = diffODDays > 0 ? true : false;
              const interestPrcnt = ifOverDue
                ? bungaod_tarifthn
                : bunga_tarifthn;
              const interest =
                pjmPrincipal * (interestPrcnt / 100 / 360) * diffDays;
              this.frmdt.ttlinterest += interest;
            }
          }

          if (model_pinjaman == "PAB") {
            // START total beban sampai tanggal pelunasan
            this.frmdt.ttlinstalment =
              bbnPinjamanPelunasan.sum_angsrn_installment;
            this.frmdt.ttlprincipal = bbnPinjamanPelunasan.sum_angsrn_principal;

            this.frmdt.ttllatecharge =
              bbnPinjamanPelunasan.sum_nilai_dendahrian;
            this.frmdt.ttlinterest = bbnPinjamanPelunasan.sum_angsrn_interest;

            this.frmdt.ttlangsuran =
              this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
            this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
            this.frmdt.dendalain = 0; //tanyakan kembali dendalain
            this.frmdt.pinalty = 0; //tanyakan kembali pinalty

            // END

            // START HITUNG ULANG DENDA SAMPAI TANGGAL PELUNASAN
            if (diffDays > 0) {
              diffDays += 1;
              const ttlDendaSmpaiLns =
                diffDays *
                (bbnPinjamanCurr.sum_angsrn_principal *
                  (this.model.denda_tarifhri / 100));
              this.frmdt.ttllatecharge += ttlDendaSmpaiLns;
            }
            // END
          }

          this.frmdt.net_ttlprincipal =
            this.frmdt.ttlprincipal - this.frmdt.diskon_principal_amount;

          this.frmdt.net_ttlinterest =
            this.frmdt.ttlinterest - this.frmdt.diskon_interest_amount;

          this.frmdt.net_ttlangsuran =
            this.frmdt.ttlprincipal +
            this.frmdt.ttlinterest -
            this.frmdt.diskon_angsuran_amount;

          this.frmdt.net_ttllatecharge =
            this.frmdt.ttllatecharge - this.frmdt.diskon_latecharge_amount;

          this.frmdt.net_ospokokbelumjt =
            this.frmdt.ospokokbelumjt - this.frmdt.diskon_ospokokbelumjt_amount;
          this.frmdt.net_dendalain =
            this.frmdt.dendalain - this.frmdt.diskon_dendalain_amount;
          this.frmdt.net_pinalty =
            this.frmdt.pinalty - this.frmdt.diskon_pinalty_amount;

          this.frmdt.ttlpayment =
            this.frmdt.net_ttlangsuran +
            this.frmdt.net_ttlinterest +
            this.frmdt.net_ttllatecharge +
            this.frmdt.net_ospokokbelumjt +
            this.frmdt.net_dendalain +
            this.frmdt.net_pinalty;

          this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;

          this.frmdt.ttlpayment_awal =
            this.frmdt.ttlangsuran +
            this.frmdt.ttlinterest +
            this.frmdt.ttllatecharge +
            this.frmdt.ospokokbelumjt +
            this.frmdt.dendalain +
            this.frmdt.pinalty;

          this.frmdt.ttlpayment_diskon =
            this.frmdt.diskon_angsuran_amount +
            this.frmdt.diskon_interest_amount +
            this.frmdt.diskon_latecharge_amount +
            this.frmdt.diskon_ospokokbelumjt_amount +
            this.frmdt.diskon_dendalain_amount +
            this.frmdt.diskon_pinalty_amount;

          // this.frmdt.ttlpayment =
          //   this.frmdt.ttlprincipal +
          //   this.frmdt.ttllatecharge +
          //   this.frmdt.ttlinterest -
          //   (this.frmdt.diskon_principal_amount + this.frmdt.diskon_interest_amount + this.frmdt.diskon_latecharge_amount);

          // this.frmdt.diskon_amount;

          this.ifCalculated = true;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    resetCalc() {
      this.frmdt.uraian = "";
      this.frmdt.ttlinstalmentcurrent = 0;
      this.frmdt.ttlprincipalcurrent = 0;
      this.frmdt.ttllatechargecurrent = 0;
      this.frmdt.ttlinterestcurrent = 0;
      this.frmdt.ttlinstalment = 0;
      this.frmdt.ttlprincipal = 0;
      this.frmdt.ttllatecharge = 0;
      this.frmdt.ttlinterest = 0;
      this.frmdt.ttlangsuran = 0;
      this.frmdt.ospokokbelumjt = 0;
      this.frmdt.dendalain = 0;
      this.frmdt.pinalty = 0;
      // this.frmdt.diskon_percent = 0;
      this.frmdt.diskon_principal_percent = 0;
      this.frmdt.diskon_interest_percent = 0;
      this.frmdt.diskon_angsuran_percent = 0;
      this.frmdt.diskon_latecharge_percent = 0;
      this.frmdt.diskon_ospokokbelumjt_percent = 0;
      this.frmdt.diskon_dendalain_percent = 0;
      this.frmdt.diskon_pinalty_percent = 0;
      //this.frmdt.diskon_amount = 0;
      this.frmdt.diskon_principal_amount = 0;
      this.frmdt.diskon_interest_amount = 0;
      this.frmdt.diskon_angsuran_amount = 0;
      this.frmdt.diskon_latecharge_amount = 0;
      this.frmdt.diskon_ospokokbelumjt_amount = 0;
      this.frmdt.diskon_dendalain_amount = 0;
      this.frmdt.diskon_pinalty_amount = 0;

      this.frmdt.net_ttlprincipal = 0;
      this.frmdt.net_ttlinterest = 0;
      this.frmdt.net_ttlangsuran = 0;
      this.frmdt.net_ttllatecharge = 0;
      this.frmdt.net_ospokokbelumjt = 0;
      this.frmdt.net_dendalain = 0;
      this.frmdt.net_pinalty = 0;
      this.frmdt.ttlpayment = 0;
      this.frmdt.prepaid = 0;
      this.frmdt.ttlmustpay = 0;
      this.ifCalculated = false;
    },
    tooglePrintSave(param) {
      //console.log("$param: ", param);
      if (!param) {
        this.printPelunasanpdf();
      } else {
        this.simpanCetak();
      }
    },
    async simpanCetak() {
      if (this.invalidFrmDt) {
        // console.log("validation : ", this.$v.model);
        // console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        if (this.frmdt.ttlpayment == 0) {
          this.stateTtlPay = false;
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          const pelunasankey = await pelunasan.save(this.frmdt);
          this.frmdt.pelunasankey = pelunasankey;
          toastr.success("Data berhasil disimpan");
          this.printPelunasanpdf();
          //router.push({ name: "loan.pelunasan" });
        }
      }
    },
    async printPelunasanpdf() {
      try {
        this.isLoading = true;
        this.reportUrl = await pelunasan.printPDFMemoPelunasan(
          this.frmdt.pelunasankey
        );
        this.isLoading = false;
        this.showReport = true;
      } catch (error) {
        this.showReport = false;
        this.isLoading = false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "loan.pelunasan" });
    },
    async settlement() {
      if (this.frmdt.ttlpayment == 0) {
        this.stateTtlPay = false;
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.$route.params.pelunasankey) {
            await pelunasan.settlement({
              pelunasankey: this.$route.params.pelunasankey,
            });
            router.push({ name: "loan.pelunasan" });
          }
        } catch (error) {
          toastr.error(error, "ERROR MESSAGE");
        }
      }
    },
  },
};
</script>
